import { getGroupRatingApi } from "./get-group-rating"

import type {
  AddRankPermissionRequest,
  AddRankPermissionResponse,
  CreateCustomRanksRequest,
  CreateCustomRanksResponse
} from "./types"

export const createGroupRatingApi = getGroupRatingApi.injectEndpoints({
  endpoints: builder => ({
    addRankPermission: builder.mutation<AddRankPermissionResponse, AddRankPermissionRequest>({
      query: ({ chatId, rankId, permission }) => ({
        url: `/api/v1/group/rating/rank/permission?chat_id=${chatId}`,
        method: "POST",
        body: { rank_id: rankId, permission }
      }),
      invalidatesTags: (_result, error) => (error ? [] : ["PermissionUpdate"])
    }),

    createCustomRanks: builder.mutation<CreateCustomRanksResponse, CreateCustomRanksRequest>({
      query: chatId => ({
        url: `/api/v1/group/rating/ranks?chat_id=${chatId}`,
        method: "POST"
      }),
      invalidatesTags: (_result, error) => (error ? [] : ["GroupRating", "RankUpdate"])
    })
  })
})

export const { useAddRankPermissionMutation, useCreateCustomRanksMutation } = createGroupRatingApi
